import { Box, useMantineTheme } from '@mantine/core';
import { keyframes } from '../utils/keyframes';;
import { forwardRef } from 'react';
import { useReducedMotion } from '../hooks';

const spinKeyframes = keyframes({
  '0%': { transform: 'rotate(0deg)' },
  '100%': { transform: 'rotate(360deg)' },
});

export interface GradientSpinnerProps {
  size?: number;
  thickness?: number;
  speed?: number;
  gradientVariant?: 'primary' | 'secondary' | 'tertiary';
}

const GradientSpinner = forwardRef<HTMLDivElement, GradientSpinnerProps>(
  (
    {
      size = 40,
      thickness = 4,
      speed = 1000,
      gradientVariant = 'primary',
    },
    ref
  ) => {
    const theme = useMantineTheme();
    const reducedMotion = useReducedMotion();
    const gradient = theme.other?.gradients?.[gradientVariant];

    return (
      <Box
        ref={ref}
        style={{
          width: size,
          height: size,
          borderRadius: '50%',
          background: `conic-gradient(from 0deg, transparent, ${gradient?.from || theme.primaryColor})`,
          mask: `radial-gradient(farthest-side, transparent calc(100% - ${thickness}px), #fff calc(100% - ${thickness}px))`,
          WebkitMask: `radial-gradient(farthest-side, transparent calc(100% - ${thickness}px), #fff calc(100% - ${thickness}px))`,
          animation: reducedMotion ? 'none' : `${spinKeyframes} ${speed}ms linear infinite`,
        }}
      />
    );
  }
);

GradientSpinner.displayName = 'GradientSpinner';

export default GradientSpinner;
